'use client'

import { Tabs } from '@/components/ui/tabs'
import { ParsedContent } from '@/lib/helpers/shortcode-parser'
import { PageContent } from './page-content'

interface TabData {
  value: string
  label: string
  slug: string
  detail: {
    head_html?: string | null
    footer_html?: string | null
    body_html: ParsedContent[]
  } | null
}

interface PageTabsProps {
  tabs: TabData[]
}

export function PageTabs({ tabs }: PageTabsProps) {
  const tabOptions = tabs.map((tab) => ({
    value: tab.value,
    label: tab.label,
    content: <PageContent detail={tab.detail} />,
  }))

  return (
    <div className='max-md:w-full'>
      <Tabs
        options={tabOptions}
        defaultValue={tabs[0]?.value}
        variant='shadcn'
        wrapperClassName='w-full'
        className='w-full justify-center rounded-lg bg-neutral-100 p-1 md:mx-auto md:w-fit md:min-w-0'
        triggerClassName='px-4 md:px-8'
      />
    </div>
  )
}
